<template>
  <div>
      <div>
        <div>
          <Button>+新增字典</Button>
        </div>
      </div>
      <div>
        <Table>
            <div>
              <Button >确定</Button>
              <Button >取消</Button>
            </div>
            <div >
              <Button >编辑</Button>
              <Button >删除</Button>
            </div>
        </Table>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'Zidian',
  };
</script>

<style scoped>

</style>
